const FullStory = {
  install(app, options) {
    let router         = options.router;
    let identifyCalled = false;

    app.mixin({
      mounted() {

        router.afterEach(() => {
          if (!identifyCalled && window.FS) {
            const currentUser = this.$store.getters.currentUser;

            if (currentUser.id) {
              window.FS('setIdentity', {
                uid: currentUser.id,
                properties: {
                  email: currentUser.email,
                }
              });

              identifyCalled = true;
            }
          }
        });
      }
    });
  }
};

export default FullStory;
